import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ICamera } from '@obvious.tech/constellation'

export const Camera = defineEntity('Camera', {
  endpoint: 'videomanager/api/Camera',
  schema: SNoop<ICamera>(),
})
